// removed by extract-text-webpack-plugin
module.exports = {"fixedHeaderGrid":"_3DzAH"};


//////////////////
// WEBPACK FOOTER
// ./admin/permissions/components/FixedHeaderGrid.css
// module id = 2593
// module chunks = 3